/**
 * [駅名標](https://ja.wikipedia.org/wiki/%E9%A7%85%E5%90%8D%E6%A8%99)
 * [鉄道路線のラインカラー一覧](https://dic.nicovideo.jp/a/%E9%89%84%E9%81%93%E8%B7%AF%E7%B7%9A%E3%81%AE%E3%83%A9%E3%82%A4%E3%83%B3%E3%82%AB%E3%83%A9%E3%83%BC%E4%B8%80%E8%A6%A7)
 * [駅名標あつめ](https://ekimeihyo.net/e/jre/)
 */
export const COLOR_GREEN = '#378640'; // JR東日本
export const COLOR_PURPLE = '#0072ba'; // JR西日本
export const COLOR_ORANGE = '#f15a22'; // 中央線（快速）,青梅線,五日市線
export const COLOR_YELLOW = '#ffd400'; // 中央・総武線（各駅停車）
export const COLOR_WATER = '#00bae8'; // 京浜東北線・根岸線

export const COLOR_WHITE = '#fff';
export const COLOR_GRAY = '#aaa';
